var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`col-12 ${_vm.layout === 1 ? 'col-lg-7' : ''} bg-dark p-1 rounded`},[(_vm.cargos.length > 0)?_c('div',{style:({
      height: _vm.layout === 2 ? '500px' : '300px',
      width: '100%',
    }),attrs:{"id":"distributed-columns-cargos"}}):[_vm._m(0)]],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"d-flex flex-column align-items-center justify-content-center",staticStyle:{"min-height":"300px"}},[_c('i',{staticClass:"fas fa-spinner fa-spin mb-2",staticStyle:{"font-size":"1.5rem"}}),_vm._v(" Cargando gráfico... ")])
}]

export { render, staticRenderFns }